(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lc-cb-collage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__lcCbgPops) return;
    window.__lcCbgPops = true;
    var closePops = function (except) {
      document.querySelectorAll('.lc-cbg__hs.is-open').forEach(function (h) {
        if (h === except) return;
        h.classList.remove('is-open');
        h.querySelector('.lc-cbg__pop').hidden = true;
        h.querySelector('.lc-cbg__dot').setAttribute('aria-expanded', 'false');
      });
    };
    document.addEventListener('click', function (e) {
      var dot = e.target.closest && e.target.closest('.lc-cbg__dot');
      if (dot) {
        e.preventDefault();
        var hs = dot.parentNode;
        var open = !hs.classList.contains('is-open');
        closePops(hs);
        hs.classList.toggle('is-open', open);
        hs.querySelector('.lc-cbg__pop').hidden = !open;
        dot.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      if (e.target.closest && e.target.closest('.lc-cbg__pop-btn')) setTimeout(function () { closePops(); }, 0);
      else if (!(e.target.closest && e.target.closest('.lc-cbg__pop'))) closePops();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePops(); });
    var closeLists = function (except) {
      document.querySelectorAll('.lc-cbg__panel:not([hidden])').forEach(function (p) {
        if (p === except) return;
        p.hidden = true;
        var b = p.parentNode.querySelector('.lc-cbg__lookbtn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    };
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.lc-cbg__lookbtn');
      if (btn) {
        e.preventDefault();
        var panel = btn.parentNode.querySelector('.lc-cbg__panel');
        if (!panel) return;
        var open = panel.hidden;
        closeLists(panel);
        closePops();
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      if (e.target.closest && (e.target.closest('.lc-cbg__item') || e.target.closest('.lc-cbg__panel-x'))) { setTimeout(function () { closeLists(); }, 0); return; }
      if (!(e.target.closest && e.target.closest('.lc-cbg__panel'))) closeLists();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLists(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-cb-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lc-cb-hero')) return;
    customElements.define('lc-cb-hero', class extends HTMLElement {
      connectedCallback() {
        if (this._on) return;
        this._on = true;
        if (this.hasAttribute('data-nocrumb')) this.hideCrumbs();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.classList.add('is-js');
        const mos = this.querySelector('[data-cbh-mos]');
        const base = mos && mos.querySelector('img.lc-cbh__base');
        if (!base) return;
        mos.classList.add('is-prep');
        const undo = () => mos.classList.remove('is-prep');
        const go = () => { try { this.split(mos, base, reduce); } catch (e) { undo(); } if (!mos.classList.contains('is-split')) undo(); };
        setTimeout(() => { if (!mos.classList.contains('is-split')) undo(); }, 5000);
        if (base.complete && base.naturalWidth) go(); else base.addEventListener('load', go, { once: true });
      }

      // Hide the theme's breadcrumb ("Inicio / …") above this page
      hideCrumbs() {
        const top = this.getBoundingClientRect().top + window.scrollY;
        document.querySelectorAll('nav, ol, ul, div, p').forEach((n) => {
          if (n.closest('lc-cb-hero, header, header-component, dialog')) return;
          const r = n.getBoundingClientRect();
          if (r.height === 0 || r.height > 90 || r.top + window.scrollY > top + 2) return;
          const t = (n.textContent || '').replace(/\s+/g, ' ').trim();
          if (!/^(inicio|home|accueil|inici)/i.test(t) || !n.querySelector('a') || t.length > 200) return;
          n.style.display = 'none';
          const sec = n.closest('.shopify-section');
          if (sec && !sec.contains(this) && (sec.textContent || '').replace(/\s+/g, ' ').trim().length < 200) sec.style.display = 'none';
        });
      }

      // Cut the mosaic PNG into its tiles, using the transparent gaps between them
      split(mos, base, reduce) {
        const NW = base.naturalWidth, NH = base.naturalHeight;
        const w = 420, h = Math.max(1, Math.round(w * NH / NW));
        const c = document.createElement('canvas'); c.width = w; c.height = h;
        const cx = c.getContext('2d', { willReadFrequently: true });
        cx.drawImage(base, 0, 0, w, h);
        const a = cx.getImageData(0, 0, w, h).data;
        const lab = new Int32Array(w * h).fill(-1);
        const boxes = [];
        const stack = [];
        for (let i = 0; i < w * h; i++) {
          if (lab[i] !== -1 || a[i * 4 + 3] < 60) continue;
          const id = boxes.length; let x0 = w, y0 = h, x1 = 0, y1 = 0, n = 0;
          lab[i] = id; stack.push(i);
          while (stack.length) {
            const p = stack.pop(); const x = p % w, y = (p - x) / w; n++;
            if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
            const nb = [p - 1, p + 1, p - w, p + w];
            for (let k = 0; k < 4; k++) {
              const q = nb[k];
              if (q < 0 || q >= w * h) continue;
              if ((k === 0 && x === 0) || (k === 1 && x === w - 1)) continue;
              if (lab[q] === -1 && a[q * 4 + 3] >= 60) { lab[q] = id; stack.push(q); }
            }
          }
          boxes.push({ id, x0, y0, x1, y1, n });
        }
        let tiles = boxes.filter((b) => b.n > w * h * 0.002);
        let L = lab;
        if (tiles.length < 2) {
          // No transparent gaps: cut the photo into rounded tiles ourselves
          const g = this.cut(w, h, mos.dataset);
          L = g.lab; tiles = g.boxes;
          if (tiles.length < 2) return;
        }
        const sx = NW / w, sy = NH / h, pad = 3;
        const cells = [];
        tiles.forEach((b) => {
          const bx0 = Math.max(0, b.x0 - pad), by0 = Math.max(0, b.y0 - pad), bx1 = Math.min(w - 1, b.x1 + pad), by1 = Math.min(h - 1, b.y1 + pad);
          const bw = bx1 - bx0 + 1, bh = by1 - by0 + 1;
          // mask of this tile (slightly grown so its soft edge is kept)
          const m = document.createElement('canvas'); m.width = bw; m.height = bh;
          const mx = m.getContext('2d'); const md = mx.createImageData(bw, bh);
          for (let y = 0; y < bh; y++) for (let x = 0; x < bw; x++) {
            let on = false;
            for (let dy = -2; dy <= 2 && !on; dy++) for (let dx = -2; dx <= 2 && !on; dx++) {
              const X = x + bx0 + dx, Y = y + by0 + dy;
              if (X >= 0 && Y >= 0 && X < w && Y < h && L[Y * w + X] === b.id) on = true;
            }
            if (on) md.data[(y * bw + x) * 4 + 3] = 255;
          }
          mx.putImageData(md, 0, 0);
          const fx = Math.round(bx0 * sx), fy = Math.round(by0 * sy), fw = Math.round(bw * sx), fh = Math.round(bh * sy);
          const t = document.createElement('canvas'); t.width = fw; t.height = fh;
          const tx = t.getContext('2d');
          tx.drawImage(base, fx, fy, fw, fh, 0, 0, fw, fh);
          tx.globalCompositeOperation = 'destination-in';
          tx.imageSmoothingEnabled = true;
          tx.drawImage(m, 0, 0, fw, fh);
          const cell = document.createElement('div'); cell.className = 'lc-cbh__cell';
          cell.style.left = (bx0 / w * 100) + '%'; cell.style.top = (by0 / h * 100) + '%';
          cell.style.width = (bw / w * 100) + '%'; cell.style.height = (bh / h * 100) + '%';
          const f = document.createElement('div'); f.className = 'lc-cbh__f';
          f.style.setProperty('--fd', (6 + Math.random() * 4).toFixed(2) + 's');
          f.style.setProperty('--fdel', (-Math.random() * 6).toFixed(2) + 's');
          f.appendChild(t); cell.appendChild(f); mos.appendChild(cell);
          const ccx = ((b.x0 + b.x1) / 2) / w - 0.5, ccy = ((b.y0 + b.y1) / 2) / h - 0.5;
          const len = Math.hypot(ccx, ccy) || 0.01;
          cell._dir = [ccx / len, ccy / len]; cell._dist = len; cell._z = 0.4 + Math.random() * 1.1; cell._c = t;
          cells.push(cell);
        });
        mos.classList.add('is-split');
        if (!reduce) this.animateCells(mos, cells);
      }

      // Rounded Voronoi tiles with even gaps, inside an organic outline
      cut(w, h, ds) {
        let seed = (parseInt(ds.seed, 10) || 1) * 9301 + 49297;
        const rnd = () => { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
        const N = Math.max(4, parseInt(ds.tiles, 10) || 14);
        const gap = Math.max(1, (parseFloat(ds.gap) || 8)) * w / 420;
        const organic = ds.shape !== 'rectangle';
        const ar = w / h;
        const cols = Math.max(2, Math.round(Math.sqrt(N * ar))), rows = Math.max(2, Math.round(N / cols));
        const pts = [];
        for (let r = 0; r < rows; r++) for (let c = 0; c < cols; c++) {
          pts.push([(c + 0.5 + (rnd() - 0.5) * 0.75) / cols * w, (r + 0.5 + (rnd() - 0.5) * 0.75) / rows * h]);
        }
        const n = pts.length;
        const lab = new Int32Array(w * h).fill(-1);
        const edge = new Float32Array(w * h);
        for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
          let b1 = 1e9, b2 = 1e9, i1 = 0;
          for (let i = 0; i < n; i++) {
            const dx = x - pts[i][0], dy = y - pts[i][1], d = Math.sqrt(dx * dx + dy * dy);
            if (d < b1) { b2 = b1; b1 = d; i1 = i; } else if (d < b2) b2 = d;
          }
          lab[y * w + x] = i1; edge[y * w + x] = b2 - b1;
        }
        // organic outline (a soft cloud), or the plain rectangle
        const ph1 = rnd() * 6.28, ph2 = rnd() * 6.28;
        const inside = (x, y) => {
          if (!organic) return x > gap && y > gap && x < w - gap && y < h - gap;
          const nx = (x / w - 0.5) * 2, ny = (y / h - 0.5) * 2;
          const t = Math.atan2(ny, nx), rr = Math.hypot(nx, ny);
          const lim = 0.9 + 0.07 * Math.sin(3 * t + ph1) + 0.05 * Math.sin(5 * t + ph2);
          return rr < lim;
        };
        // per tile: keep pixels away from the borders, then round the corners (blur + threshold)
        const out = new Int32Array(w * h).fill(-1);
        const boxes = [];
        const R = Math.max(3, Math.round(gap * 2.4));
        for (let i = 0; i < n; i++) {
          let x0 = w, y0 = h, x1 = 0, y1 = 0;
          for (let p = 0; p < w * h; p++) if (lab[p] === i) { const x = p % w, y = (p - x) / w; if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
          if (x1 < x0) continue;
          x0 = Math.max(0, x0 - R); y0 = Math.max(0, y0 - R); x1 = Math.min(w - 1, x1 + R); y1 = Math.min(h - 1, y1 + R);
          const bw = x1 - x0 + 1, bh = y1 - y0 + 1;
          let m = new Float32Array(bw * bh);
          for (let y = 0; y < bh; y++) for (let x = 0; x < bw; x++) {
            const X = x + x0, Y = y + y0, p = Y * w + X;
            m[y * bw + x] = (lab[p] === i && edge[p] > gap && inside(X, Y)) ? 1 : 0;
          }
          for (let pass = 0; pass < 2; pass++) {
            const t = new Float32Array(bw * bh);
            for (let y = 0; y < bh; y++) { let acc = 0; for (let x = -R; x < bw + R; x++) { if (x + R < bw) acc += m[y * bw + x + R]; if (x - R - 1 >= 0) acc -= m[y * bw + x - R - 1]; if (x >= 0 && x < bw) t[y * bw + x] = acc / (2 * R + 1); } }
            const u = new Float32Array(bw * bh);
            for (let x = 0; x < bw; x++) { let acc = 0; for (let y = -R; y < bh + R; y++) { if (y + R < bh) acc += t[(y + R) * bw + x]; if (y - R - 1 >= 0) acc -= t[(y - R - 1) * bw + x]; if (y >= 0 && y < bh) u[y * bw + x] = acc / (2 * R + 1); } }
            m = u;
          }
          let cnt = 0, a0 = w, b0 = h, a1 = 0, b1 = 0;
          for (let y = 0; y < bh; y++) for (let x = 0; x < bw; x++) {
            if (m[y * bw + x] > 0.62) { const X = x + x0, Y = y + y0; out[Y * w + X] = i; cnt++; if (X < a0) a0 = X; if (X > a1) a1 = X; if (Y < b0) b0 = Y; if (Y > b1) b1 = Y; }
          }
          if (cnt > w * h * 0.004) boxes.push({ id: i, x0: a0, y0: b0, x1: a1, y1: b1, n: cnt });
        }
        return { lab: out, boxes };
      }

      animateCells(mos, cells) {
        // Tiles fly in and lock into place
        cells.forEach((c) => {
          if (!c._c.animate) return;
          const d = 24 + Math.random() * 36;
          const dx = c._dir[0] * d;
          const dy = c._dir[1] * d;
          const r = (Math.random() - 0.5) * 8;
          c._c.animate([
            { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + r + 'deg) scale(.94)', opacity: 0 },
            { transform: 'translate(0,0) rotate(0) scale(1)', opacity: 1 }
          ], { duration: 1400, delay: 100 + c._dist * 700 + Math.random() * 200, easing: 'cubic-bezier(.22,.8,.3,1)', fill: 'backwards' });
        });
        // Mouse: tiles follow at different depths, hovered tile lifts
        let mx = 0, my = 0, tmx = 0, tmy = 0;
        if (window.matchMedia('(pointer: fine)').matches) {
          mos.addEventListener('pointermove', (e) => {
            const r = mos.getBoundingClientRect();
            tmx = (e.clientX - r.left) / r.width - 0.5;
            tmy = (e.clientY - r.top) / r.height - 0.5;
            mos.classList.add('is-hover');
            const hot = e.target.closest && e.target.closest('.lc-cbh__cell');
            cells.forEach((c) => c.classList.toggle('is-hot', c === hot));
          });
          mos.addEventListener('pointerleave', () => { tmx = 0; tmy = 0; mos.classList.remove('is-hover'); cells.forEach((c) => c.classList.remove('is-hot')); });
        }
        // Scroll: tiles spread apart as the mosaic leaves the screen
        let visible = true;
        if ('IntersectionObserver' in window) new IntersectionObserver((es) => { visible = es[0].isIntersecting; }).observe(mos);
        const tick = () => {
          if (visible) {
            mx += (tmx - mx) * 0.08; my += (tmy - my) * 0.08;
            const r = mos.getBoundingClientRect();
            const spread = Math.max(0, Math.min(1.2, -r.top / (r.height || 1))) * 22;
            cells.forEach((c) => {
              const px = -mx * 8 * c._z + c._dir[0] * spread * (0.6 + c._dist);
              const py = -my * 6 * c._z + c._dir[1] * spread * (0.6 + c._dist);
              c.style.transform = 'translate3d(' + px.toFixed(1) + 'px,' + py.toFixed(1) + 'px,0)';
            });
          }
          requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lc-cgrid')) {
    customElements.define('lc-cgrid', class extends HTMLElement {
      connectedCallback() {
        this.classList.add('is-js');
        this.init();

        // Everything below is delegated, so it keeps working after the content is swapped
        this.addEventListener('click', (e) => {
          const more = e.target.closest('[data-lc-more]');
          if (more) { e.preventDefault(); this.loadMore(more); return; }
          if (e.target.closest('[data-lc-filter-open]')) { this.openFilters(); return; }
          // type links, filter chips and "clear all" refresh the products in place
          const link = e.target.closest('.lc-cgrid__type, .lc-cgrid__chip, .lc-cgrid__clear, [data-lc-live]');
          if (link && link.href && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
            e.preventDefault();
            this.refresh(link.href);
          }
        });
        this.addEventListener('change', (e) => {
          const sort = e.target.closest('[data-lc-sort]');
          if (!sort) return;
          this.setSortLabel();
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', sort.value);
          url.searchParams.delete('page');
          this.refresh(url.toString());
        });

        // mark the first page too, so the back button can return to it
        if (!history.state || !history.state.lcGrid) history.replaceState({ ...(history.state || {}), lcGrid: true }, '', window.location.href);
        this.onPop = () => { if (history.state && history.state.lcGrid) this.refresh(window.location.href, false); };
        window.addEventListener('popstate', this.onPop);
        this.onScroll = () => this.setStickyTop();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.setStickyTop();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        window.removeEventListener('popstate', this.onPop);
        this.removeDialog();
      }

      // (re)wire the parts that live outside the delegated listeners
      init() {
        this.removeDialog();
        const dialog = this.querySelector('[data-lc-filter]');
        this.dialog = dialog;
        if (dialog) {
          dialog.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
          dialog.addEventListener('click', (e) => {
            if (e.target === dialog || e.target.closest('[data-lc-filter-close]')) dialog.close();
            const link = e.target.closest('a[href]');
            if (link && !e.metaKey && !e.ctrlKey) { e.preventDefault(); dialog.close(); this.refresh(link.href); }
          });
          dialog.querySelector('form')?.addEventListener('submit', (e) => {
            e.preventDefault();
            const form = e.currentTarget;
            const params = new URLSearchParams();
            new FormData(form).forEach((v, k) => { if (v !== '') params.append(k, v); });
            const url = new URL(form.action, window.location.origin);
            url.search = params.toString();
            dialog.close();
            this.refresh(url.toString());
          });
        }
        this.setSortLabel();
      }

      removeDialog() {
        if (this.dialog && this.dialog.parentElement === document.body) this.dialog.remove();
      }

      openFilters() {
        const dialog = this.dialog;
        if (!dialog) return;
        if (dialog.parentElement !== document.body) document.body.appendChild(dialog);
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }

      setSortLabel() {
        const sort = this.querySelector('[data-lc-sort]');
        const label = this.querySelector('.lc-cgrid__sort-label');
        if (sort && label) label.dataset.current = sort.options[sort.selectedIndex]?.text || '';
      }

      sectionUrl(href) {
        const url = new URL(href, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        return url.toString();
      }

      // Filter / sort without leaving the page: fetch this section for the new URL and swap it in
      async refresh(href, push = true) {
        if (this.loading) this.loading.abort();
        const ctrl = new AbortController();
        this.loading = ctrl;
        this.classList.add('is-loading');
        try {
          const res = await fetch(this.sectionUrl(href), { credentials: 'same-origin', signal: ctrl.signal });
          if (!res.ok) throw new Error(res.status);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const fresh = doc.querySelector('lc-cgrid');
          if (!fresh) throw new Error('no grid');
          // keep the type menu scrolled where it was
          const typesScroll = this.querySelector('.lc-cgrid__types')?.scrollLeft || 0;
          this.removeDialog();
          this.innerHTML = fresh.innerHTML;
          const types = this.querySelector('.lc-cgrid__types');
          if (types) types.scrollLeft = typesScroll;
          this.init();
          if (push) {
            const clean = new URL(href, window.location.origin);
            clean.searchParams.delete('section_id');
            history.pushState({ lcGrid: true }, '', clean.pathname + clean.search);
          }
          // bring the first products into view if the visitor had scrolled far down
          const bar = this.querySelector('.lc-cgrid__bar');
          if (bar && bar.getBoundingClientRect().top < 0) {
            const top = window.scrollY + this.getBoundingClientRect().top - (parseInt(getComputedStyle(this).getPropertyValue('--lc-sticky-top'), 10) || 0);
            window.scrollTo({ top, behavior: 'smooth' });
          }
          if (window.lcCards) {
            window.lcCards.queueSwatches();
            setTimeout(() => { window.lcCards.equalize(); window.lcCards.fades(); }, 50);
          }
        } catch (err) {
          if (err.name === 'AbortError') return;
          window.location.href = href;
          return;
        } finally {
          if (this.loading === ctrl) { this.loading = null; this.classList.remove('is-loading'); }
        }
      }

      // keep the toolbar right under Horizon's sticky header (which can hide on scroll)
      setStickyTop() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          const header = document.querySelector('#header-group, .header-section, header-component, .header');
          let top = 0;
          if (header) {
            const pos = getComputedStyle(header).position;
            const r = header.getBoundingClientRect();
            if ((pos === 'sticky' || pos === 'fixed') && r.bottom > 0) top = Math.round(r.bottom);
            else {
              const inner = header.querySelector('[data-sticky-state], .header__row, header');
              if (inner) {
                const ir = inner.getBoundingClientRect();
                const ip = getComputedStyle(inner).position;
                if ((ip === 'sticky' || ip === 'fixed') && ir.bottom > 0) top = Math.round(ir.bottom);
              }
            }
          }
          this.style.setProperty('--lc-sticky-top', top + 'px');
        });
      }

      async loadMore(btn) {
        const next = btn.getAttribute('href');
        if (!next || btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        try {
          const res = await fetch(this.sectionUrl(next), { credentials: 'same-origin' });
          if (!res.ok) throw new Error(res.status);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const grid = this.querySelector('[data-lc-cgrid-items]');
          const items = doc.querySelectorAll('[data-lc-cgrid-items] > [data-lc-cgrid-item]');
          items.forEach((item) => grid.appendChild(document.importNode(item, true)));

          const shownEl = this.querySelector('[data-lc-showing]');
          if (shownEl) {
            const total = Number(shownEl.dataset.total) || 0;
            const shown = grid.querySelectorAll('[data-lc-cgrid-item]').length;
            shownEl.textContent = (shownEl.dataset.template || '').replace('[shown]', shown).replace('[total]', total);
            const bar = this.querySelector('[data-lc-progress]');
            if (bar && total) bar.style.width = Math.min(100, Math.round((shown / total) * 100)) + '%';
          }
          const newNext = doc.querySelector('[data-lc-more]');
          if (newNext) btn.setAttribute('href', newNext.getAttribute('href'));
          else btn.remove();

          const pageUrl = new URL(next, window.location.origin);
          window.history.replaceState({ lcGrid: true }, '', pageUrl.pathname + pageUrl.search);

          if (window.lcCards) {
            window.lcCards.queueSwatches();
            setTimeout(() => { window.lcCards.equalize(); window.lcCards.fades(); }, 50);
          }
        } catch (err) {
          window.location.href = next;
          return;
        }
        btn.classList.remove('is-loading');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-edito-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function hideCrumbs() {
      var h = document.querySelector('.lc-eh[data-lc-nocrumb]');
      if (!h) return;
      var top = h.getBoundingClientRect().top + window.scrollY;
      Array.prototype.forEach.call(document.querySelectorAll('nav, ol, ul, div, p'), function (n) {
        if (n.closest('.lc-eh, header, header-component, .lc-tp-header, dialog')) return;
        var r = n.getBoundingClientRect();
        if (r.height === 0 || r.height > 80 || r.top + window.scrollY > top) return;
        var t = (n.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^(inicio|home|accueil|inici)\s*[\/›>»|·]/i.test(t) && n.querySelectorAll('a').length >= 1 && t.length < 120) n.style.display = 'none';
      });
    }
    function setup() {
      hideCrumbs();
      var hero = document.querySelector('.lc-eh[data-lc-tp]');
      var root = document.documentElement;
      if (!hero) { root.classList.remove('lc-tp', 'lc-tp--solid'); return; }
      var header = document.querySelector('header-component') ||
        document.querySelector('.shopify-section-group-header-group header') ||
        document.querySelector('header');
      if (!header) return;
      var sec = header.closest('.shopify-section') || header;
      var wrap = hero.closest('.shopify-section') || hero;
      sec.classList.add('lc-tp-header');
      header.classList.add('lc-tp-bar');
      Array.prototype.forEach.call(header.querySelectorAll('*'), function (n) {
        if (n.closest('details[open], dialog, [role="dialog"]')) return;
        var cs = window.getComputedStyle(n);
        if (cs.backgroundColor && cs.backgroundColor !== 'rgba(0, 0, 0, 0)' && n.getBoundingClientRect().height <= sec.getBoundingClientRect().height + 2 && n.getBoundingClientRect().width > 200) n.classList.add('lc-tp-bar');
      });
      root.classList.add('lc-tp');
      function measure() {
        wrap.style.marginTop = '';
        var top = sec.getBoundingClientRect().top;
        var h = sec.getBoundingClientRect().height;
        var gap = wrap.getBoundingClientRect().top - top;
        root.style.setProperty('--lc-tp-h', h + 'px');
        wrap.style.marginTop = (-gap) + 'px';
        wrap.style.position = 'relative';
        wrap.style.zIndex = '1';
      }
      function onScroll() {
        var limit = Math.max(40, hero.getBoundingClientRect().height * 0.15);
        root.classList.toggle('lc-tp--solid', window.scrollY > limit);
      }
      measure();
      onScroll();
      if (!window.__lcTpBound) {
        window.__lcTpBound = true;
        window.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });
        window.addEventListener('resize', function () { measure(); onScroll(); });
        window.addEventListener('load', measure);
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
    document.addEventListener('shopify:section:load', setup);
    document.addEventListener('shopify:section:unload', function () { setTimeout(setup, 0); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-edito-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lcErLook) return;
    window.lcErLook = true;
    var closeAll = function (except) {
      document.querySelectorAll('.lc-er__panel:not([hidden])').forEach(function (p) {
        if (p === except) return;
        p.hidden = true;
        var b = p.parentNode.querySelector('.lc-er__lookbtn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    };
    /* Colour swatches under a tile: switch the tile to that colour instead of leaving the page */
    var erCache = {};
    var erRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var erMoney = function (c) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(c / 100); }
      catch (err) { return (c / 100).toFixed(2); }
    };
    var erTitle = function (t) { return String(t).toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); }); };
    var erUrl = function (u, w) { u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
    var erSwap = function (tile, swatch) {
      var handle = swatch.getAttribute('data-handle');
      if (!handle || swatch.hasAttribute('data-selected')) return;
      tile.classList.add('is-swapping');
      (erCache[handle] = erCache[handle] || fetch(erRoot + 'products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : Promise.reject(); }))
        .then(function (p) {
          var url = p.url || erRoot + 'products/' + p.handle;
          var imgs = (p.images || []).filter(Boolean);
          var n = parseInt(tile.getAttribute('data-img-n'), 10) || 1;
          var src = imgs[n - 1] || imgs[0] || p.featured_image;
          var old = tile.querySelector('.lc-er__media img');
          if (old && src && !tile.hasAttribute('data-custom-img')) {
            var im = document.createElement('img');
            im.alt = erTitle(p.title);
            im.decoding = 'async';
            im.sizes = old.getAttribute('sizes') || '50vw';
            im.srcset = [360, 540, 720, 960, 1200, 1600].map(function (w) { return erUrl(src, w) + ' ' + w + 'w'; }).join(', ');
            im.src = erUrl(src, 960);
            if (old.getAttribute('style')) im.setAttribute('style', old.getAttribute('style'));
            old.replaceWith(im);
          }
          tile.querySelectorAll('a.lc-er__media').forEach(function (a) { a.href = url; });
          tile.querySelectorAll('.lc-er__plus').forEach(function (a) { a.href = url; a.setAttribute('data-lc-quick-add', p.handle); });
          if (!tile.hasAttribute('data-custom-name')) tile.querySelectorAll('.lc-er__name').forEach(function (e) { e.textContent = erTitle(p.title); });
          tile.querySelectorAll('.lc-er__price').forEach(function (e) {
            e.textContent = (p.price_min !== p.price_max ? (tile.getAttribute('data-from') || 'From') + ' ' : '') + erMoney(p.price_min);
          });
          if (tile.hasAttribute('data-imgs') && imgs.length > 1) {
            tile.setAttribute('data-imgs', imgs.slice(0, 8).map(function (u) { return erUrl(u, 1200); }).join('|'));
            tile.removeAttribute('data-cur');
            tile._erPre = {};
            tile._erToken = (tile._erToken || 0) + 1;
            tile.classList.remove('is-loading-img');
            tile.classList.remove('is-alt');
            erNeighbours(tile, (parseInt(tile.getAttribute('data-img-n'), 10) || 1) - 1);
          }
          swatch.parentElement.querySelectorAll('linkify-product-colors-swatch').forEach(function (x) { x.toggleAttribute('data-selected', x === swatch); });
        })
        .catch(function () { window.location.href = erRoot + 'products/' + handle; })
        .then(function () { tile.classList.remove('is-swapping'); });
    };
    /* Arrows: browse the product's photos inside the tile */
    var erSrcset = function (u) {
      return [540, 720, 960, 1200].map(function (w) { return erUrl(u.replace(/([?&])width=\d+&?/, '$1'), w) + ' ' + w + 'w'; }).join(', ');
    };
    var erList = function (tile) { return (tile.getAttribute('data-imgs') || '').split('|').filter(Boolean); };
    // Download a photo in advance so it is ready when the shopper swipes to it
    var erPreload = function (tile, i) {
      var list = erList(tile);
      if (list.length < 2) return;
      i = (i + list.length) % list.length;
      tile._erPre = tile._erPre || {};
      if (tile._erPre[i]) return;
      var old = tile.querySelector('.lc-er__media img');
      var im = new Image();
      im.decoding = 'async';
      im.sizes = (old && old.getAttribute('sizes')) || '50vw';
      im.srcset = erSrcset(list[i]);
      im.src = list[i];
      tile._erPre[i] = im;
    };
    var erNeighbours = function (tile, i) { erPreload(tile, i + 1); erPreload(tile, i - 1); };
    var erShow = function (tile, i, step) {
      var list = erList(tile);
      if (list.length < 2) return;
      var start = (parseInt(tile.getAttribute('data-img-n'), 10) || 1) - 1;
      if (start >= list.length) start = 0;
      i = (i + list.length) % list.length;
      tile.setAttribute('data-cur', i);
      var token = (tile._erToken || 0) + 1;
      tile._erToken = token;
      var old = tile.querySelector('.lc-er__media img');
      if (!old) return;
      if (!tile._erStyle && old.getAttribute('style')) tile._erStyle = old.getAttribute('style');
      tile._erPre = tile._erPre || {};
      var im = tile._erPre[i];
      if (!im) {
        im = document.createElement('img');
        im.decoding = 'async';
        im.sizes = old.getAttribute('sizes') || '50vw';
        im.srcset = erSrcset(list[i]);
        im.src = list[i];
        tile._erPre[i] = im;
      }
      if (im === old) return;
      im.alt = old.alt;
      if (i === start && tile._erStyle) im.setAttribute('style', tile._erStyle); else im.removeAttribute('style');
      var done = false;
      var swap = function () {
        if (done || tile._erToken !== token) return;
        done = true;
        var cur = tile.querySelector('.lc-er__media img');
        if (!cur) return;
        tile.classList.toggle('is-alt', i !== start);
        cur.replaceWith(im);
        if (step && im.animate) im.animate([{ opacity: 0.4, transform: 'translateX(' + (step > 0 ? 24 : -24) + 'px)' }, { opacity: 1, transform: 'none' }], { duration: 260, easing: 'ease-out' });
      };
      // keep the current photo on screen until the next one is ready
      if (im.complete && im.naturalWidth) swap();
      else {
        tile.classList.add('is-loading-img');
        var ready = function () { tile.classList.remove('is-loading-img'); swap(); };
        if (im.decode) im.decode().then(ready, ready); else { im.onload = ready; im.onerror = ready; }
        setTimeout(ready, 6000);
      }
      erNeighbours(tile, i);
    };
    // Get the next and previous photos ready when a product comes close to the screen
    if ('IntersectionObserver' in window) {
      var erIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          erIO.unobserve(en.target);
          var start = (parseInt(en.target.getAttribute('data-img-n'), 10) || 1) - 1;
          erNeighbours(en.target, start);
        });
      }, { rootMargin: '300px 0px' });
      var erWatch = function () { document.querySelectorAll('.lc-er__tile[data-imgs]').forEach(function (t) { erIO.observe(t); }); };
      erWatch();
      document.addEventListener('shopify:section:load', erWatch);
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.lc-er__arrow');
      if (!a) return;
      e.preventDefault();
      var tile = a.closest('.lc-er__tile');
      var start = (parseInt(tile.getAttribute('data-img-n'), 10) || 1) - 1;
      var cur = tile.hasAttribute('data-cur') ? parseInt(tile.getAttribute('data-cur'), 10) : start;
      var st = parseInt(a.getAttribute('data-er-step'), 10);
      erShow(tile, cur + st, st);
    });
    // Swipe left / right on a product photo to browse its photos (phones and tablets)
    var erStep = function (tile, step) {
      var start = (parseInt(tile.getAttribute('data-img-n'), 10) || 1) - 1;
      var cur = tile.hasAttribute('data-cur') ? parseInt(tile.getAttribute('data-cur'), 10) : start;
      erShow(tile, cur + step, step);
    };
    var erTouch = null;
    var erPrep = function () {
      document.querySelectorAll('.lc-er__tile[data-imgs] .lc-er__mwrap').forEach(function (w) { w.style.touchAction = 'pan-y'; });
    };
    erPrep();
    document.addEventListener('shopify:section:load', erPrep);
    document.addEventListener('touchstart', function (e) {
      var w = e.target.closest && e.target.closest('.lc-er__tile[data-imgs] .lc-er__mwrap');
      if (!w || e.touches.length !== 1 || (e.target.closest && e.target.closest('.lc-er__arrow, .lc-er__hs, .lc-er__lookbtn, .lc-er__panel, .lc-er__plus'))) { erTouch = null; return; }
      erTouch = { tile: w.closest('.lc-er__tile'), x: e.touches[0].clientX, y: e.touches[0].clientY };
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (!erTouch) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - erTouch.x;
      var dy = t.clientY - erTouch.y;
      var tile = erTouch.tile;
      erTouch = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      tile._erSwiped = Date.now();
      erStep(tile, dx < 0 ? 1 : -1);
    }, { passive: true });
    document.addEventListener('touchcancel', function () { erTouch = null; }, { passive: true });
    // a swipe should not open the product page
    document.addEventListener('click', function (e) {
      var tile = e.target.closest && e.target.closest('.lc-er__tile');
      if (tile && tile._erSwiped && Date.now() - tile._erSwiped < 500) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    var erSwatchHit = function (e) {
      var sw = e.target.closest && e.target.closest('.lc-er__tile linkify-product-colors-swatch[data-handle]');
      return sw ? { sw: sw, tile: sw.closest('.lc-er__tile') } : null;
    };
    document.addEventListener('click', function (e) {
      var hit = erSwatchHit(e);
      if (!hit) return;
      e.preventDefault();
      e.stopPropagation();
      erSwap(hit.tile, hit.sw);
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var hit = erSwatchHit(e);
      if (!hit) return;
      e.preventDefault();
      e.stopPropagation();
      erSwap(hit.tile, hit.sw);
    }, true);
    var closePops = function (except) {
      document.querySelectorAll('.lc-er__hs.is-open').forEach(function (h) {
        if (h === except) return;
        h.classList.remove('is-open');
        h.querySelector('.lc-er__pop').hidden = true;
        h.querySelector('.lc-er__dot').setAttribute('aria-expanded', 'false');
      });
    };
    document.addEventListener('click', function (e) {
      var dot = e.target.closest && e.target.closest('.lc-er__dot');
      if (dot) {
        e.preventDefault();
        var hs = dot.parentNode;
        var open = !hs.classList.contains('is-open');
        closePops(hs);
        hs.classList.toggle('is-open', open);
        hs.querySelector('.lc-er__pop').hidden = !open;
        dot.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      if (e.target.closest && e.target.closest('.lc-er__pop-btn')) setTimeout(function () { closePops(); }, 0);
      else if (!(e.target.closest && e.target.closest('.lc-er__pop'))) closePops();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePops(); });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.lc-er__lookbtn');
      if (btn) {
        e.preventDefault();
        var panel = btn.parentNode.querySelector('.lc-er__panel');
        if (!panel) return;
        var open = panel.hidden;
        closeAll(panel);
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      if (e.target.closest && (e.target.closest('.lc-er__row') || e.target.closest('.lc-er__panel-x'))) { setTimeout(function () { closeAll(); }, 0); return; }
      if (!(e.target.closest && e.target.closest('.lc-er__panel'))) closeAll();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
